<div class="component-dialog-terms">
    <div class="cdt-header">
        <!-- <span class="cdt-header-text">AUTORIZACIÓN PARA EL TRATAMIENTO DE DATOS PERSONALES</span> -->
        <span class="cdt-header-text">Autorización para el tratamiento de datos personales</span>
    </div>
    <div class="cdt-body">
        La autorización para el tratamiento de los datos personales, permite a Xtracking,
        recolectar, transferir, almacenar, usar, circular, suprimir, compartir, actualizar y transmitir,
        para efectos de cumplir con los objetivos establecidos por la ley.
        En todo caso, el Titular del dato siempre tendrá la opción de revocar la autorización y/o
        solicitar la supresión del dato. El titular del dato autoriza de manera previa, expresa e
        informada la inclusión de su información en las bases de datos administradas por
        Xtracking cuando haga uso de https://www.xtracking.co/ y de los demás canales de que
        disponga Xtracking para tal fin, así como el tratamiento y la utilización de la misma por
        parte de Xtracking, sus entidades vinculadas, controladas o afiliadas o por otra
        entidad con la que tenga una relación comercial.
        Por razones de eficiencia, seguridad y de estar a la vanguardia en tecnología, los servicios
        de XTRACKING en donde está alojado nuestro sistema y base de datos podrán estar
        ubicados fuera de Colombia. Por lo anterior, el Titular del dato autoriza a XTRACKING
        para que en caso de que sea necesario o pertinente, envíe sus datos personales a los
        servicios de XTRACKING en cualquier país que considere conveniente para los fines del
        tratamiento autorizado o para propósitos de almacenamiento y/o eventuales servicios de
        hosting o cloud computing (computación en la nube) que XTRACKING contrate o
        requiera.
    </div>
    <div class="cdt-footer" (click)="onClickAccept()">
        <span class="cdt-footer-btn-text">Aceptar</span>
    </div>
</div>